
import { Component, Vue, Watch } from 'vue-property-decorator'

import BacHeaderWithMenue from '@/templates/BacHeaderWithMenue.vue'
import BacBlueButton from '@/components/BacBlueButton.vue'
import BacHr from '@/components/BacHr.vue'
import BacTeamCard from '@/components/teams/BacTeamCard.vue'
import Waiting from '@/components/Waiting.vue'
import BacModal from '@/components/BacModal.vue'
import BacInput from '@/components/BacInput.vue'
import BacButton from '@/components/BacButton.vue'

import { Team } from '@/lib/models/Team'
import { StringUtils } from '../lib/utils/StringUtils'
import { FileCheck } from '@/lib/utils/FileCheck'
import { RallyRound } from '../lib/models/RallyRound'
import { Http } from '@/lib/utils/Http'
import UIkit from 'uikit'
import { faThemeisle } from '@fortawesome/free-brands-svg-icons'
import { checkAllowedToAccessPermission } from '@/lib/utils/RallyRoundAccess'

@Component({
  components: {
    BacHeaderWithMenue,
    BacBlueButton,
    BacHr,
    BacTeamCard,
    Waiting,
    BacModal,
    BacInput,
    BacButton
  }
})
export default class Teams extends Vue {
  loggedInTeam: Team|null = null
  allTeams: Team[] = []
  numberOfTeamCards = 6
  defaultVehicleImage = ''
  search = ''
  selectedFilter = -1

  // for edit team modal
  startNumbers = []
  startNumber = -1
  teamname = ''

  get teamPageUrl (): string {
    if (!this.loggedInTeam || !this.loggedInTeam.id) {
      // return '/team' + window.location.search
      return '#'
    }
    if (this.loggedInTeam.id) {
      return `/teams/${this.loggedInTeam.rallyRoundId}/team/${this.loggedInTeam.id}`
    }
    return StringUtils.updateURLParameter('/team/' + window.location.search, 'tid', this.loggedInTeam.id.toString())
  }

  get allTeamsSortedSearchedAndFiltered (): Team[] {
    if (this.selectedFilter === -1) {
      return this.allTeamsSortedAndSearched
    }
    return this.allTeamsSortedAndSearched.filter(team => {
      if (team.vehicles && team.vehicles.length && team.vehicles && team.vehicles.length) {
        team.vehicles.forEach(vehicle => {
          return vehicle.classes.find((vehicleClass: any) => {
            return vehicleClass.class_id === this.selectedFilter
          })
        })
      }
    })
  }

  get allTeamsSortedAndSearched (): Team[] {
    if (!this.search) {
      return this.allTeamsSorted
    }

    // match exact team number and return if found
    let teamsSearched = this.allTeamsSorted.filter((team: Team) => {
      if (team.number === this.search.replace(/#/g, '')) {
        return true
      }
      return false
    })
    if (teamsSearched.length) {
      return teamsSearched
    }

    // match search includes teamname and return if found
    teamsSearched = this.allTeamsSorted.filter((team: Team) => {
      if (!team.name) {
        return false
      }
      if (team.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
        return true
      }
      return false
    })
    if (teamsSearched.length) {
      return teamsSearched
    }

    // match teamnumber includes and return if found
    teamsSearched = this.allTeamsSorted.filter((team: Team) => {
      if (!team.number) {
        return false
      }
      if (team.number.indexOf(this.search.replace(/#/g, '')) !== -1) {
        return true
      }
      return false
    })
    return teamsSearched
  }

  get allTeamsSorted (): Team[] {
    return this.allTeams.sort((a: Team, b: Team) => {
      if (!a || !b || !a.number || !b.number || !parseInt(a.number) || !parseInt(b.number)) { return -1 }
      return parseInt(a.number) - parseInt(b.number)
    })
  }

  get rallyRound () {
    return this.$store.state.PageURLRallyRound.rallyRound ? this.$store.state.PageURLRallyRound.rallyRound : new RallyRound()
  }

  async saveTeam () {
    if (!this.loggedInTeam) {
      return
    }
    if (this.startNumber > 0) {
      this.loggedInTeam.number = this.startNumber.toString()
    }
    if (this.teamname) {
      this.loggedInTeam.name = this.teamname
    }
    await this.loggedInTeam?.update()
    UIkit.modal('#edit-team-modal').hide()
  }

  mounted () {
    checkAllowedToAccessPermission(this.$route.params.rallyRoundId)

    this.defaultVehicleImage = require('@/assets/img/rally/default-vehicle-images/car.jpg')
    window.addEventListener('scroll', this.onScroll)
    this.fetchAllTeams()
    this.onScroll()
    setInterval(this.onScroll, 1000)
    this.fetchLoggedInTeam()

    if (this.rallyRound && this.rallyRound.id) {
      if (localStorage.getItem(`all-teams-${this.rallyRound.id}`)) {
        const allTeamsJson = localStorage.getItem(`all-teams-${this.rallyRound.id}`)
        if (allTeamsJson) {
          this.allTeams = JSON.parse(allTeamsJson)
        }
      }
    }
  }

  async loadAvailableStartnumber () {
    const startNumbers = await Http.request('/api/team-number')
    this.startNumbers = await startNumbers.json()
  }

  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  }

  onScroll () {
    const bottomOfWindow = (
      document.documentElement.scrollHeight -
      (Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight)
    ) < 1000

    if (bottomOfWindow) {
      this.numberOfTeamCards += 3
    }
  }

  loadingAllTeams = false
  @Watch('$store.state.PageURLRallyRound.rallyRound')
  async fetchAllTeams () {
    const rallyRound = this.$store.state.PageURLRallyRound.rallyRound
    if (!rallyRound || !rallyRound.name) {
      return
    }
    if (this.allTeams.length > 0) {
      return
    }

    if (this.loadingAllTeams) {
      return
    }

    this.loadingAllTeams = true

    this.allTeams = await rallyRound.getTeams()
    localStorage.setItem(`all-teams-${rallyRound.id}`, JSON.stringify(this.allTeams))
    this.loggedInTeam = await rallyRound.getLoggedInTeam()
    if (!this.loggedInTeam?.name || !this.loggedInTeam?.number) {
      // team has no name or number, show popup to choose one!
      UIkit.modal('#edit-team-modal').show()
      if (!this.loggedInTeam?.number) {
        this.loadAvailableStartnumber()
      }
    }
    this.loadingAllTeams = false
  }

  @Watch('$store.state.PageURLRally.rally')
  async fetchLoggedInTeam () {
    const rally = this.$store.state.PageURLRally.rally
    if (!rally) {
      return
    }
    if (this.$store.state.PageURLRally.rally.id === 6) {
      this.defaultVehicleImage = require('@/assets/img/rally/default-vehicle-images/moped.jpg')
    } else if (this.$store.state.PageURLRally.rally.id === 9) {
      this.defaultVehicleImage = require('@/assets/img/rally/default-vehicle-images/boat.jpg')
    }
  }
}
